<template>
  <div class="flex-d-c-c shortcut-body">
    <div class="title">{{ title }}</div>
    <div class="describe">{{ describe }}</div>
  </div>
</template>

<script>
export default {
  name: 'shortcut',
  props: {
    title: {
      type: String,
      required: true
    },
    describe: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.shortcut-body:hover {
  border: 1px dashed var(--theme-color-customized-1);
}

.shortcut-body {
  height: 84px;
  // width: 220px;
  width: calc(25% - 80px);
  // background: #eefbff;
  background: var(--theme-color-customized-2);
  padding: 8px;
  border-radius: 16px;
  border: 1px solid #fff;
  // margin: 0px 64px;
  user-select: none;
  cursor: pointer;

  .title,
  .describe {
    margin-top: 8px;
    text-align: left;
  }

  .title {
    font-size: 18px;
    font-weight: bolder;
    font-family: "sans-serif";
    // color: #333;
    width: 100%;
    color: var(--theme-color-customized-1);
  }

  .describe {
    // width: calc(100% - 32px);
    // color: var(--theme-color-customized-1);
    color: #7988B7;
  }
}
</style>